import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FunctionsService } from '../../services/functions.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxStripeModule } from '@nomadreservations/ngx-stripe';
import { BreadcrumbModule } from 'xng-breadcrumb';
import { MatTableModule } from '@angular/material/table'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSortModule } from '@angular/material/sort'
import { ManageDocumentsComponent } from './manage-documents/manage-documents.component';
import { UserManagementRoutingModule } from './user-management-routing.module';
import { NgxPermissionsModule } from 'ngx-permissions';
import { UserManagementComponent } from './user-management.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PdfViewComponent } from './manage-documents/pdf-view/pdf-view.component';
import { environment } from 'src/environments/environment';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { AddUserComponent } from './add-user/add-user.component';
import { EditUserComponent } from './edit-user/edit-user.component';
import { ViewUserComponent } from './view-user/view-user.component';
import { UpdatePictureComponent } from './update-picture/update-picture.component';
import { BulkImportComponent } from './bulk-import/bulk-import.component';
import { ManageGroupsComponent } from './manage-groups/manage-groups.component';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AuthInterceptorProvider } from 'src/app/services/token/token-interceptor.service';
import { CreateAggressorComponent } from './view-user/create-agressor/create-agressor.component';

@NgModule({
    declarations: [
        BulkImportComponent,
        UserManagementComponent,
        AddUserComponent,
        EditUserComponent,
        ViewUserComponent,
        ManageDocumentsComponent,
        ManageGroupsComponent,
        UpdatePictureComponent,
        PdfViewComponent,
        CreateAggressorComponent
    ],
    imports: [
        UserManagementRoutingModule,
        BreadcrumbModule,
        CommonModule,
        FormsModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatNativeDateModule,
        MatTableModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
        MatSortModule,
        NgbModule,
        NgxPermissionsModule,
        NgxSpinnerModule,
        NgxStripeModule.forRoot(environment.stripe_pk),
        ReactiveFormsModule,
        TranslateModule,
        SelectDropDownModule,
        NgMultiSelectDropDownModule,
        PdfViewerModule
    ],
    providers: [FunctionsService, AuthInterceptorProvider]
})
export class UserManagementModule { }
